var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrunchbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#146aff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "crunchbase"), /*#__PURE__*/React.createElement("path", {
    d: "M23.707 16.68c0 0.017 0.001 0.037 0.001 0.057 0 1.452-1.177 2.629-2.629 2.629s-2.629-1.177-2.629-2.629c0-1.452 1.177-2.629 2.629-2.629 0.477 0 0.925 0.127 1.311 0.35l-0.013-0.007c0.784 0.451 1.309 1.277 1.331 2.226l0 0.003zM23.985 20.136c-0.376 0.325-0.815 0.592-1.294 0.777l-0.030 0.010c-0.494 0.197-1.066 0.312-1.664 0.312-0.96 0-1.851-0.294-2.588-0.797l0.016 0.010v0.475h-1.887v-13.209h1.874v5.136c0.634-0.434 1.403-0.719 2.233-0.786l0.017-0.001h0.337c0.002 0 0.005 0 0.007 0 2.533 0 4.586 2.053 4.586 4.586 0 1.393-0.621 2.64-1.601 3.481l-0.006 0.005zM9.808 19.080c0.321 0.15 0.697 0.237 1.093 0.237 1.060 0 1.974-0.625 2.393-1.527l0.007-0.016h2.074c-0.509 2.035-2.321 3.518-4.48 3.518-2.547 0-4.611-2.064-4.611-4.611s2.065-4.611 4.611-4.611c2.159 0 3.971 1.483 4.473 3.486l0.007 0.032h-2.074c-0.426-0.918-1.34-1.543-2.399-1.543-1.456 0-2.637 1.181-2.637 2.637 0 1.060 0.625 1.974 1.527 2.393l0.016 0.007zM27.997 1.004h-23.993c-1.654 0.007-2.992 1.346-2.999 2.998v23.994c0.007 1.654 1.346 2.992 2.998 2.999h23.994c1.654-0.007 2.992-1.346 2.999-2.998v-23.994c-0.007-1.654-1.346-2.992-2.998-2.999h-0.001z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrunchbase);
export default __webpack_public_path__ + "static/media/crunchbase.72096cac8af81563f0176224cbfecae8.svg";
export { ForwardRef as ReactComponent };